import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useFormikContext } from 'formik';
import { EventTitleEnum } from '../common/enums/common.enum';
import { BasicEventConfig, ParentEventsOptionDto } from '../common/interfaces/event.interface';
import { EventIcon } from './EventSelector/ParentEventSelector.styles';

interface FormValues {
  selectedGroups: string[];
  selectedEvents: EventTitleEnum[];
  eventConfigs: Record<EventTitleEnum, BasicEventConfig>;
}

interface EventTabsProps {
  activeTab: EventTitleEnum;
  setActiveTab: (tab: EventTitleEnum) => void;
  parentEvents: ParentEventsOptionDto[];
}

const STORAGE = process.env.REACT_APP_STORAGE as string;

const EventTabs: React.FC<EventTabsProps> = ({ activeTab, setActiveTab, parentEvents }) => {
  const { values } = useFormikContext<FormValues>();

  if (!values.selectedEvents.length) return null;

  return (
    <Box sx={{ whiteSpace: 'nowrap', mb: 3, maxWidth: 'calc(100vw - 400px)' }}>
      <Tabs
        value={activeTab}
        onChange={(_e, newTab) => setActiveTab(newTab as EventTitleEnum)}
        textColor="primary"
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        sx={{
          '& .MuiTab-root': { fontSize: 16, fontWeight: '600', textTransform: 'none' }
        }}
      >
        {values.selectedEvents.map(ev => {
          const parentEventIcon = parentEvents.find(p => p.title === ev)?.icon;
          const iconSrc = parentEventIcon ? `${STORAGE}${parentEventIcon}` : undefined;
          const isSelected = activeTab === ev;

          return (
            <Tab
              key={ev}
              value={ev}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {iconSrc && <EventIcon src={iconSrc} alt={ev} selected={isSelected} />}
                  <span>{ev}</span>
                </Box>
              }
            />
          );
        })}
      </Tabs>
    </Box>
  );
};

export default EventTabs;
